<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <button
      class="language-toggle-button"
      @click="toggleLanguage"
    >
      <!-- แสดงธงตามภาษาที่เลือก -->
      <img
        v-if="currentLanguage === 'th'"
        src="@/assets/images/flags/en.png"
        alt="en"
        width="50"
        height="30"
      >
      <img
        v-if="currentLanguage === 'en'"
        src="@/assets/images/flags/jp.png"
        alt="jp"
        width="50"
        height="30"
      >
      <img
        v-if="currentLanguage === 'jp'"
        src="@/assets/images/flags/th.png"
        alt="th"
        width="50"
        height="30"
      >
    </button>
    <!-- Left Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ username }}
            </p>
            <span class="user-status">{{ roles }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="profileImage"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="showEmployeeModal(userid)"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>{{ $t('Profile') }}</span>
        </b-dropdown-item>
        <span @click="logout">
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center">
            <feather-icon
              size="16"
              icon="MessageSquareIcon"
              class="mr-50"
            />
            {{ $t('logout') }}
          </b-dropdown-item>
        </span>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <!--model user-->
    <EmployeeModal
      :show="modalShowfix"
      :employee="selectedEmployee"
      @close="modalShowfix = false"
    />

  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import apiAuth from '@/services/auth'
import { getRolesFromToken } from '@/services/JwtDecoder'
import EmployeeModal from '@/views/AdminReviwer/EmployeeModel_fix.vue'
import { useToast } from 'vue-toastification'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    EmployeeModal,

    // Navbar Components
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: '',
      username: '',
      profileImage: '',
      userid: '',
      selectedEmployee: {},
      modalShowfix: false,
      calendars: [],
      currentLanguage: this.$i18n.locale,
    }
  },
  created() {
    // ดึงค่าจาก localStorage
    this.userid = localStorage.getItem('id')
    this.username = localStorage.getItem('username')
    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
    const base64Image = localStorage.getItem('profileImage')
    if (base64Image) {
    // ตรวจสอบประเภทของภาพและเพิ่ม prefix
      this.profileImage = `data:image/png;base64,${base64Image}` // หรือใช้ 'image/jpeg' ถ้าเป็น JPEG
    }
    this.fetchUserCalendars()
  },

  methods: {
    logout() {
      localStorage.clear()
      this.$router.push({ name: 'login' }) // เปลี่ยนเส้นทางไปที่หน้า login หลังจากออกจากระบบ
    },

    toggleLanguage() {
      let newLang
      if (this.currentLanguage === 'th') {
        newLang = 'en' // Change from Thai to English
      } else if (this.currentLanguage === 'en') {
        newLang = 'jp' // Change from English to Japanese
      } else {
        newLang = 'th' // Change from Japanese to Thai
      }
      this.$i18n.locale = newLang
      this.currentLanguage = newLang
      this.$store.dispatch('changeLanguage', newLang)
      localStorage.setItem('language', newLang)
    },

    async showEmployeeModal(userId) {
      try {
        const response = await apiAuth.get(`auth/showbyid/${userId}`)
        console.log(response)
        this.selectedEmployee = response.data
        this.modalShowfix = true
      } catch (error) {
        console.error('Error fetching employee data:', error)
      }
    },

    async fetchUserData() {
    // เพิ่มโค้ดสำหรับดึงข้อมูลผู้ใช้ใหม่ที่นี่
      this.userid = localStorage.getItem('id')
      this.profileImage = localStorage.getItem('profileImage')
      this.username = localStorage.getItem('username')
      this.accessToken = localStorage.getItem('accessToken')
      this.roles = getRolesFromToken(this.accessToken)
    },

    showNotification(calendar) {
      const eventStartDate = new Date(calendar.timestart)
      const currentDate = new Date()
      const timeDifference = eventStartDate - currentDate
      const daysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24))

      const formattedStartDate = new Intl.DateTimeFormat('th-TH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(eventStartDate)

      const formattedEndDate = new Intl.DateTimeFormat('th-TH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(calendar.timeend))

      // Create toast content using Vue's render function approach
      const toastContent = this.$createElement('div', { class: 'custom-toast' }, [
        this.$createElement('div', { class: 'toast-body' }, [
          this.$createElement('div', {}, [`${this.$t('pmdevice')}: ${calendar.device.deviceName}`]),
          this.$createElement('div', {}, [`${this.$t('details')}: ${calendar.description}`]),
          this.$createElement('div', {}, [
            `${this.$t('time')}: ${formattedStartDate} - ${formattedEndDate}`,
          ]),
        ]),
      ])

      const isToday = eventStartDate.toDateString() === currentDate.toDateString()
      const title = isToday
        ? `${this.$t('today')} (${calendar.title})`
        : `${this.$t('after')} ${daysRemaining} ${this.$t('day')} (${calendar.title})`
      // Use Bootstrap Vue toast with render function
      this.$bvToast.toast([toastContent], {
        title,
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-right',
        noAutoHide: true,
        appendToast: true,
        toastClass: 'custom-toast-container',
        headerClass: 'toast-header',
      })
    },

    async fetchUserCalendars() {
      try {
        // คำนวณวันที่เริ่มต้น (ย้อนหลัง 3 วัน) และวันที่สิ้นสุด (ไปข้างหน้า 3 วัน)
        const currentDate = new Date()

        // วันที่เริ่มต้นย้อนหลัง 3 วัน
        const startDate = new Date(currentDate)
        startDate.setDate(currentDate.getDate() - 3)

        // วันที่สิ้นสุดไปข้างหน้า 3 วัน
        const endDate = new Date(currentDate)
        endDate.setDate(currentDate.getDate() + 3)

        // แปลงเป็น ISO 8601 (YYYY-MM-DDTHH:mm) สำหรับส่งไปใน API
        const start = startDate.toISOString().slice(0, 16)
        const end = endDate.toISOString().slice(0, 16)
        console.log(`Fetching events from ${start} to ${end}`)

        // ส่งคำขอ API เพื่อดึงข้อมูลปฏิทิน
        const response = await apiAuth.get('/calendar/getUserCalendar', {
          params: {
            userId: this.userid,
            start,
            end,
          },
        })

        this.calendars = response.data
        console.log(this.calendars)

        // ตรวจสอบว่าเหตุการณ์ใดเกิดขึ้นในช่วง 6 วัน (ย้อนหลัง 3 วันและไปข้างหน้า 3 วัน)
        this.calendars.forEach(calendar => {
          const eventStartTime = new Date(calendar.timestart).getTime()
          const currentTime = new Date().getTime()
          const timeDifference = eventStartTime - currentTime

          // หากเหตุการณ์เกิดขึ้นในวันนี้
          const eventDate = new Date(calendar.timestart)
          const isToday = eventDate.toDateString() === currentDate.toDateString()

          // หากเหตุการณ์เกิดขึ้นในวันนี้
          if (isToday) {
            this.showNotification(calendar)
          }

          // หากเวลาที่เหลืออยู่ในช่วง 3 วัน
          if (timeDifference <= 3 * 24 * 60 * 60 * 1000 && timeDifference > 0) {
            this.showNotification(calendar)
          }
        })
      } catch (error) {
        console.error('Error fetching user calendar:', error)
      }
    },

    login() {
      this.fetchUserData()
    },
  },
}

</script>
<style>
.custom-toast-container {
  min-width: 350px;
  max-width: 500px;
  margin: 0.5rem;
}

.custom-toast {
  font-size: 1rem;
  padding: 0.75rem 1rem;
  line-height: 1.6;
}

.toast-header {
  font-size: 1.25rem;
  font-weight: 600;
  padding: 0.5rem 0;
  padding-left: 1rem;
}

.toast-body {
  padding: 0.5rem 0;
}

.toast-body div {
  margin-bottom: 0.5rem;
}

.b-toaster.b-toaster-top-right {
  top: 1rem;
  right: 1rem;
  z-index: 1100;
}

.language-toggle-button {
  background: transparent; /* ไม่มีพื้นหลัง */
  border: none; /* ไม่มีกรอบ */
  padding: 0; /* ไม่มี padding */
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เมื่อวางเมาส์บนปุ่ม */
  outline: none; /* ไม่มีกรอบที่เกิดจากการกด */
}

.language-toggle-button img {
  vertical-align: middle; /* ปรับแนวแนวตั้งของรูปภาพ */
}

@media (max-width: 360px) {
  .custom-toast-container {
  min-width: 80%;
  max-width: 100%;
  margin: 0.5rem;
}
}

</style>
